module.exports = __webpack_public_path__ + "static/media/iphone_12_red.3d392c13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_12_red.png
// module id = 2091
// module chunks = 0